import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { expansionPanelItem }from '../domain/expansionPanel';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '80%',
      margin: '0% 10%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    colorTop: {
      // background: '#3366CC',
    },
    colorBottom: {
      // background: '#C0C0C0',
    },
  }),
);

interface Props {
  expansionPanelItem: expansionPanelItem[],
}

const ControlledExpansionPanels: React.FC<Props> = (props) => {

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState<string | false>('panel1');

  const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const expansionPanels = props.expansionPanelItem.map((item, index) => {
    const title = item['title'];
    const content = item['content'];
    const panel = 'panel' + String(index+1);
    return (
      <ExpansionPanel
        expanded={expanded === panel}
        onChange={handleChange(panel)}
        key={index}
        className={classes.colorBottom}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className={classes.colorTop}
        >
          <Typography className={classes.heading}>
            {title}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            {content}
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    )
  });

  return (
    <React.Fragment>
      <div className={classes.root}>
        {expansionPanels}
      </div>
    </React.Fragment>
  );
}

export default ControlledExpansionPanels;
